import { Button } from '@eliadmin/core/src/components/ui/button';
import { RealtyFilter } from './realty-filter';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useRealtyStore } from '../../../stores/realty-store';
import styles from '../realty-listing.module.css';
import { clearRealtyFilter } from '../../../utils/realty-filter-contract';
import type { UnderConstructionSearchCapability } from './realty-filter-recipe';

type RealtyFilterLeftProps = {
  underConstructionSearchCapability?: UnderConstructionSearchCapability;
};

export const RealtyFilterLeft = ({
  underConstructionSearchCapability = 'unavailable',
}: RealtyFilterLeftProps) => {
  const { t } = useTranslations();
  const { clearFilters, applyFilter, filter } = useRealtyStore();
  const categorySettings = useGlobalStore(state => state.templateSettings?.realty_category);
  const showApply = categorySettings?.filter_button_in_filter?.enabled === true;
  const showReset = categorySettings?.reset_button_in_filter?.enabled === true;

  const resetFilter = () => {
    const clearedFilter = clearRealtyFilter(filter);
    clearFilters();
    applyFilter(clearedFilter);
  };

  return (
    <div className={styles.desktopFilter} data-eli-part="listing-desktop-filter">
      <RealtyFilter
        variant="desktop"
        underConstructionSearchCapability={underConstructionSearchCapability}
      />
      {showApply && (
        <Button
          className={styles.desktopFilterApply}
          data-eli-part="realty-filter-apply"
          onClick={() => applyFilter(filter)}
        >
          {t('text174')}
        </Button>
      )}
      {showReset && (
        <Button
          type="button"
          variant="secondary"
          className={styles.desktopFilterReset}
          data-eli-part="realty-filter-reset"
          onClick={resetFilter}
        >
          {t('text3384')}
        </Button>
      )}
    </div>
  );
};
